/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_List_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style guide list" |
*
* @param {Style_Guide_Manager_List_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_list_aria_label = /** @type {((inputs?: Style_Guide_Manager_List_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_List_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des guides de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste der Stilrichtlinien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco delle guide di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список руководств по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de guías de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格指南列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली मार्गदर्शिका सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de guia de estilo")
	return /** @type {LocalizedString} */ ("Style guide list")
});